import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useRouter } from '@shared/router';
import { getLastRefund } from '../../../../Checkout/store/order/selectors';
import { REFUND_ROUTES } from '../model';

export const useRefundHeaderTitle = () => {
	const { t } = useTranslation('Refund');
	const router = useRouter();
	const lastRefund = useSelector(getLastRefund);

	if (router.currentPath === REFUND_ROUTES.REQUEST && lastRefund) {
		return t('Request.Title');
	}

	return t('Layout.Title');
};
